import { Injectable } from '@angular/core';
import { Observable, Subject, Subscriber } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChatDB } from '../../shared/data/chat/chat';
import { chat, ChatUsers } from '../model/chat.model';
import { ChatMessage, Room, RoomAssigned } from '../model/chat.message';
import { ChatUserTyping, statusSocketResponse } from '../model/user-interfaces';

var today = new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  public getMessages: Subject<ChatMessage> = new Subject<ChatMessage>();
  public unassignedRoom: Subject<RoomAssigned> = new Subject<RoomAssigned>();
  public closeRoom: Subject<Room> = new Subject<any>();
  public onlineStatus: Subject<statusSocketResponse> = new Subject<statusSocketResponse>();
  public mentionAgent: Subject<any> = new Subject<any>();

  public observer: Subscriber<{}>;
  public chat: any[] = []
  public users: any[] = []
  public userTyping: Subject<ChatUserTyping> = new Subject<ChatUserTyping>();

  constructor() {
    this.chat = ChatDB.chat
    // console.log('chat service:-', this.chat);
    this.users = ChatDB.chatUser
  }

  // Get User Data
  public getUsers(): Observable<ChatUsers[]> {
    const users = new Observable(observer => {
      observer.next(this.users);
      observer.complete();
    });
    return <Observable<ChatUsers[]>>users;
  }

  // Get cuurent user
  public getCurrentUser() {
    return this.getUsers().pipe(map(users => {
      return users.find((item) => {
        return item.authenticate === 0;
      });
    }));
  }

  // chat to user
  public chatToUser(id: number) {
    return this.getUsers().pipe(map(users => {
      return users.find((item) => {
        return item.id === id;
      });
    }));
  }

  // Get users chat
  public getUserChat(): Observable<chat[]> {
    const chat = new Observable(observer => {
      observer.next(this.chat);
      observer.complete();
    });
    return <Observable<chat[]>>chat;
  }

  // Get chat History
  public getChatHistory(id: number) {
    return this.getUserChat().pipe(map(users => {
      return users.find((item) => {
        return item.id === id;
      });
    }));
  }

  // Send Message to user
  public sendMessage(chat) {
    this.chat.filter(chats => {
      if (chats.id == chat.receiver) {
        chats.message.push({ sender: chat.sender, time: today.toLowerCase(), text: chat.message })
        setTimeout(function () {
          document.querySelector(".chat-history").scrollBy({ top: 200, behavior: 'smooth' });
        }, 310)
        this.responseMessage(chat)
      }
    })
  }

  public responseMessage(chat) {

    this.chat.filter(chats => {
      if (chats.id == chat.receiver) {
        setTimeout(() => {
          chats.message.push({ sender: chat.receiver, time: today.toLowerCase(), text: 'Hey This is ' + chat.receiver_name + ', Sorry I busy right now, I will text you later' })
        }, 2000);
        setTimeout(function () {
          document.querySelector(".chat-history").scrollBy({ top: 200, behavior: 'smooth' });
        }, 2310)
      }
    })
  }

  // set messages receiving through socket
  setMessages(message: ChatMessage) {
    this.getMessages.next(message);
  }

  //t
  get getMessagesSocket() {
    return this.getMessages.asObservable();
  }

  // set messages receiving through socket
  setUnassignedRoom(message: RoomAssigned) {
    this.unassignedRoom.next(message);
  }

  //t
  get getUnassignedRoom() {
    return this.unassignedRoom.asObservable();
  }

  // set messages receiving through socket
  setClosedChatRoom(message) {
    this.closeRoom.next(message);
  }

  //t
  get getClosedChatRoom() {
    return this.closeRoom.asObservable();
  }

  // set messages receiving through socket
  setOnlineStatus(message) {
    this.onlineStatus.next(message);
  }

  // set user typing receiving through socket
  setUserTyping(message: ChatUserTyping) {
    this.userTyping.next(message);
  }

  // get user typing anywhere receive it
  get getUserTyping() {
    return this.userTyping.asObservable();
  }

  //t
  get getOnlineStatus() {
    return this.onlineStatus.asObservable();
  }

  // set messages receiving through socket
  setMentionAgent(message) {
    this.mentionAgent.next(message);
  }

  //t
  get getMentionAgent() {
    return this.mentionAgent.asObservable();
  }

}
